/* tslint:disable:import-spacing */
/*
tslint:disable:typedef-whitespace
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}        from '@/util/i.command';
import {DecisionPoint}   from '@/models/scenario/decision.point';
import {WorkBloxEditor}  from './work.blox.editor';

/**
 *
 * @class SetEndLocCommand
 *
 * @brief reversible updates of the ending decision point for a work block
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class SetEndLocCommand implements ICommand {

  private oldValue: DecisionPoint;
  private newValue: DecisionPoint;
  private editor:   WorkBloxEditor;

  constructor(oldValue: DecisionPoint, newValue: DecisionPoint, editor: WorkBloxEditor) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    this.editor.setEndLoc(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.editor.setEndLoc(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    const a = (this.oldValue instanceof DecisionPoint) ? this.oldValue.asString() : '';
    const b = (this.newValue instanceof DecisionPoint) ? this.newValue.asString() : '';

    return '[endloc] ' + a + ' => ' + b;
  }

}
